/* tslint:disable */
/* eslint-disable */
/**
 * BlackFriday API
 * The API Documentation for BlackFriday
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import type { OutAdminProductDTO } from "./OutAdminProductDTO";
import {
  OutAdminProductDTOFromJSON,
  OutAdminProductDTOFromJSONTyped,
  OutAdminProductDTOToJSON
} from "./OutAdminProductDTO";

/**
 *
 * @export
 * @interface AdminProductListResponseDTO
 */
export interface AdminProductListResponseDTO {
  /**
   *
   * @type {number}
   * @memberof AdminProductListResponseDTO
   */
  total: number;
  /**
   *
   * @type {Array<OutAdminProductDTO>}
   * @memberof AdminProductListResponseDTO
   */
  products?: Array<OutAdminProductDTO>;
}

/**
 * Check if a given object implements the AdminProductListResponseDTO interface.
 */
export function instanceOfAdminProductListResponseDTO(value: object): boolean {
  let isInstance = true;
  isInstance = isInstance && "total" in value;

  return isInstance;
}

export function AdminProductListResponseDTOFromJSON(json: any): AdminProductListResponseDTO {
  return AdminProductListResponseDTOFromJSONTyped(json, false);
}

export function AdminProductListResponseDTOFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): AdminProductListResponseDTO {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    total: json["total"],
    products: !exists(json, "products") ? undefined : (json["products"] as Array<any>).map(OutAdminProductDTOFromJSON)
  };
}

export function AdminProductListResponseDTOToJSON(value?: AdminProductListResponseDTO | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    total: value.total,
    products: value.products === undefined ? undefined : (value.products as Array<any>).map(OutAdminProductDTOToJSON)
  };
}
